// Status utilities for the Operations Console. Maps the four health states to a
// label + color, and small helpers for boolean posture tones. Kept separate from
// rendering so the same mapping is reused by every card/table.

import { COLORS } from '../theme';
import type { HealthStatus } from './opsOverview';

export interface StatusVisual {
  label: string;
  color: string;
}

export function healthVisual(status: HealthStatus): StatusVisual {
  switch (status) {
    case 'healthy': return { label: 'Healthy', color: COLORS.success };
    case 'warning': return { label: 'Warning', color: COLORS.warn };
    case 'offline': return { label: 'Offline', color: COLORS.critical };
    case 'unknown':
    default:        return { label: 'Unknown', color: COLORS.textMuted };
  }
}

/** Green when a posture flag is "on"/enabled, muted when off. */
export function boolTone(on: boolean): string {
  return on ? COLORS.success : COLORS.textMuted;
}

/** "Enabled"/"Disabled" for boolean infrastructure rows. */
export function enabledLabel(on: boolean): string {
  return on ? 'Enabled' : 'Disabled';
}
